// App-specific config
module.exports = {
  title: "Nucla",
  description: "All of your company data, together at last.",
}
